export default __webpack_public_path__ + "static/media/Shopify_logo_2018.becd3891.svg";